// src/store/modules/OperationModule.ts
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import OperationService from '@/Services/OperationService';
import { Operation } from '@/models/Operation';

@Module({ namespaced: true })
export default class OperationModule extends VuexModule {
    operations: Operation[] = [];
    operation: Operation | null = null;
    error: string | null = null;
    totalRows:number | null = 0;

    @Mutation
    setOperations(operations: Operation[]) {
        this.operations = operations;
    }

    @Mutation
    setOperation(operation: Operation) {
        this.operation = operation;
    }

    @Mutation
    setError(error: string | null) {
        this.error = error;
    }

    @Mutation
    setTotalRows(totalRows: number) {
        this.totalRows = totalRows;
    }

    @Action
    async fetchOperation({ id, url }: { id: number, url: string }) {
        try {
            const response = await OperationService.getAll({ id, url });
            
            // Détecter si c'est un export
            const isExport = url.includes('export=excel') || url.includes('export=csv');
            
            if (isExport) {
                return response;
            }
            
            // Pour les données normales
            // TypeScript: vérifier que c'est bien un objet avec data et totalRows
            if ('data' in response && response.data) {
                this.context.commit('setOperations', response.data);
            }
            
            if ('totalRows' in response && response.totalRows) {
                this.context.commit('setTotalRows', response.totalRows);
            }
            
            return response; // Return full response for DataTable
        } catch (error: any) {
            this.context.commit('setError', error.message || 'An error occurred while fetching operations.');
            throw error;
        }
    }

    get getAll() {
        return this.operations;
    }

    get getOperation() {
        return this.operation;
    }

    get getTotalRows() {
        return this.totalRows;
    }

    get getError() {
        return this.error;
    }
}
